import ReceivingInfo from './receiving-info'
export default ReceivingInfo